import React from "react";
import { useNavigate } from "react-router-dom";
import { FileText, Stamp, Landmark, ArrowRight } from "lucide-react";

const SERVICES = [
  {
    key: "process_server",
    to: "/client/new",
    icon: FileText,
    title: "Process Server",
    desc: "Service of process — summons, complaints, subpoenas. Up to 4 documented attempts with proof of service.",
    tone: "border-emerald-300 hover:border-emerald-500",
    badge: "bg-emerald-100 text-emerald-700",
    testid: "service-select-process-server",
  },
  {
    key: "standard_notary",
    to: "/client/notary?type=standard",
    icon: Stamp,
    title: "Standard Notary",
    desc: "Mobile notarization for everyday documents — acknowledgements, jurats, and general notarial acts.",
    tone: "border-indigo-300 hover:border-indigo-500",
    badge: "bg-indigo-100 text-indigo-700",
    testid: "service-select-standard-notary",
  },
  {
    key: "enhanced_notary",
    to: "/client/notary?type=enhanced",
    icon: Landmark,
    title: "Estate Planning / Enhanced Notary",
    desc: "High-stakes signings — wills, trusts, POAs and estate documents with enhanced evidence and signer verification.",
    tone: "border-amber-300 hover:border-amber-500",
    badge: "bg-amber-100 text-amber-700",
    testid: "service-select-enhanced-notary",
  },
];

export default function ServiceSelect() {
  const nav = useNavigate();
  return (
    <div className="mx-auto max-w-4xl space-y-6 py-4" data-testid="service-select-page">
      <div>
        <h2 className="font-display text-2xl font-bold tracking-tight text-slate-900">Create an Order</h2>
        <p className="text-slate-500">Choose the service you need. We'll route you to the right workflow — your account details are used automatically.</p>
      </div>
      <div className="grid gap-4 sm:grid-cols-3">
        {SERVICES.map((s) => (
          <button
            key={s.key}
            data-testid={s.testid}
            onClick={() => nav(s.to)}
            className={`group flex flex-col rounded-2xl border-2 bg-white p-5 text-left transition ${s.tone}`}
          >
            <span className={`mb-3 inline-flex h-11 w-11 items-center justify-center rounded-xl ${s.badge}`}>
              <s.icon className="h-6 w-6" />
            </span>
            <h3 className="font-display text-lg font-bold text-slate-900">{s.title}</h3>
            <p className="mt-1.5 flex-1 text-sm text-slate-500">{s.desc}</p>
            <span className="mt-4 inline-flex items-center gap-1 text-sm font-semibold text-slate-900">
              Continue <ArrowRight className="h-4 w-4 transition group-hover:translate-x-0.5" />
            </span>
          </button>
        ))}
      </div>
    </div>
  );
}
